/** Outras moedas (13/10) — o que `GET /api/moeda` devolve. */
export interface CarteiraDeMoeda {
  moeda: string;
  comprado: number;
  vendido: number;
  gasto: number;
  saldo: number;
  /** Reais por unidade, pelo custo das compras. */
  precoMedio: number | null;
  custoDoSaldo: number;
}

export interface MovimentoDeMoeda {
  id: string;
  moeda: string;
  tipo: 'compra' | 'venda';
  quantidade: number;
  reais: number;
  data: string;
}

export interface GastoNaMoeda {
  id: string;
  moeda: string;
  valorNaMoeda: number;
  reais: number;
  descricao: string;
  data: string;
}

export interface EstadoDaMoeda {
  /** `false`: o servidor ainda não guarda moeda, e a aba não existe. */
  disponivel: boolean;
  carteiras: CarteiraDeMoeda[];
  movimentos: MovimentoDeMoeda[];
  gastos: GastoNaMoeda[];
  /** O modo viagem: a moeda em que os lançamentos estão entrando. */
  ativa: string | null;
  ativaDesde: string | null;
}

export const SEM_MOEDA: EstadoDaMoeda = {
  disponivel: false, carteiras: [], movimentos: [], gastos: [], ativa: null, ativaDesde: null,
};
